<ng-container *ngIf="(specs | filterSpecsBySource: masterInputInstructionModel || masterOutputInstructionModel || masterUseInstructionModel || masterOperation | filterSpecsByGroup: (propertiesQuery.selectAll$ | async): null: true | unique: 'PropertyId') as filteredSpecs">
  <ul class="list-unstyled mx-wx-256">
    <li *ngFor="let spec of filteredSpecs">
      <ng-container *ngIf="(propertiesQuery.selectEntity(spec.PropertyId) | async) as property">
        <app-spec-line-visibility-display [visibilityClv]="spec.MandatoryClv"/>
        <em [class.fw-light]="spec.LanguageId">{{spec.Alias || property.Name || property.Code}}</em>:
        <app-spec-value-view class="text-gray-500" [spec]="spec" [property]="property" (edit)="specModelHandlingService.editSpec(context, spec)"/>
      </ng-container>
    </li>
  </ul>
  <div class="cell-action">
    <button #editOperationItemPropertiesBtn class="btn btn-outline-default btn-sm icon" type="button" (click)="editOperationItemProperties(editOperationItemPropertiesBtn)">
      <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrow-top-right-on-square'">
      </svg>
    </button>
  </div>
  <div class="cell-action top right" *ngIf="filteredSpecs.length > 10">
    <button #editOperationItemPropertiesBtn2 class="btn btn-outline-default btn-sm icon" type="button" (click)="editOperationItemProperties(editOperationItemPropertiesBtn2)">
      <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrow-top-right-on-square'">
      </svg>
    </button>
  </div>
</ng-container>
